import React from "react";

import { PDFDownloadLink } from "@react-pdf/renderer";
import { Segment } from "semantic-ui-react";

import EstimatePdf from "components/features/EstimatePdf";

function PdfSegment({ show, pdfData }) {
	return (
		<Segment
			textAlign="right"
			style={{ padding: 0, paddingTop: "10px" }}
			basic
		>
			{show ? (
				<PDFDownloadLink
					style={{
						border: "1px solid green",
						padding: 10,
						borderRadius: 5,
						color: "green",
					}}
					document={
						<EstimatePdf
							key={"jkahjhkjdhgvahdg"}
							salesData={pdfData}
						/>
					}
					fileName={`sales_${pdfData.values.buyer}-${Date.now()}.pdf`}
				>
					{({ loading }) =>
						loading ? "Generating estimate..." : "Download estimate"
					}
				</PDFDownloadLink>
			) : null}
		</Segment>
	);
}

export default PdfSegment;
